import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Authservices from "../../services/Authservices";

interface ObjectType {
    Userlogindata: any[];
}

const initialState: ObjectType = {
    Userlogindata: [],
}

export const loginwithapi = createAsyncThunk(
    'loginwithapi',
    async (data: any) => {
        const response = await Authservices.login(data.email, data.password)
        localStorage.setItem("user", JSON.stringify(response.data.token))
        return response.data
    }
)

export const loginwithapislice = createSlice({
    name: 'Userlogindata',
    initialState,
    reducers: {},
    extraReducers: {
        [loginwithapi.fulfilled.toString()]: (state, payload) => {
            state.Userlogindata = payload.payload;
        }
    }
});

export const loginwithapireducer = loginwithapislice.reducer;